<template>
  <BittsLoading :is-loading="loading">
    <div v-if="!errored" class="cost-summary">
      <slot />
    </div>
    <BittsAlert
      v-else
      color="error"
      :message="V5_BILLING_COPY.connectorUpgrade[errorType].error.title"
      :description="
        V5_BILLING_COPY.connectorUpgrade[errorType].error.description
      "
    />
  </BittsLoading>
</template>

<script setup lang="ts">
import { BittsAlert, BittsLoading } from '@crossbeam/bitts';

import { computed } from 'vue';

import { V5_BILLING_COPY } from '@/constants/billing';

const {
  errored,
  loading,
  isSeats = true,
} = defineProps<{
  errored: boolean;
  loading: boolean;
  isSeats?: boolean;
}>();

const errorType = computed(() => (isSeats ? 'preview' : 'upgradeCard'));
</script>
